import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAccountSettingsFeature } from './account-settings.feature.state';
import {
  getFailures, getIsLoading, getNotifications, getSurvays,
} from './account-settings.selectors';
import { getNotificationsAction, getSurvaysAction, setNotificationsAction, setSurvaysAction } from './account-settings.actions';

@Injectable()
export class AccountSettingsFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public getSurvays$ = this.store.select(getSurvays);
  public getNotifications$ = this.store.select(getNotifications);
  

  constructor(private store: Store<IAccountSettingsFeature>) {}
  public getSurvays(): void {
    this.store.dispatch(getSurvaysAction());
  }
  public setSurvays(surveyQuestionAnswers): void {
    this.store.dispatch(setSurvaysAction({surveyQuestionAnswers}));
  }

  public getNotifications(): void {
    this.store.dispatch(getNotificationsAction());
  }
  public setNotifications(notifications): void {
    this.store.dispatch(setNotificationsAction({notifications}));
  }

  // public clearState(actionType: string): void {
  //   this.store.dispatch(ClearStateAction({actionType}));
  // }
}
